import { useSyncExternalStore } from 'react'
import { createFeatureFlags } from './flags-impl'
import { FeatureFlags, FeatureFlagValues } from './types'

declare global {
  interface Window {
    featureFlags: FeatureFlags
  }
}

export { type FeatureFlagValues } from './types'

let LAZY_FEATURE_FLAGS: FeatureFlags

export function getFeatureFlags(): FeatureFlags {
  if (LAZY_FEATURE_FLAGS == null) {
    LAZY_FEATURE_FLAGS = createFeatureFlags()
    window.featureFlags = LAZY_FEATURE_FLAGS
  }
  return LAZY_FEATURE_FLAGS
}

export function useFeatureFlags() {
  const flags = getFeatureFlags()
  return useSyncExternalStore(
    (callback) => {
      flags.changeSignal.connect(callback)
      return () => flags.changeSignal.disconnect(callback)
    },
    () => flags.values as FeatureFlagValues
  )
}